<!--The content below is only a placeholder and can be replaced.-->
<app-main-header></app-main-header>
<div class="Site-Content">
    <div style="text-align:center">
        <router-outlet></router-outlet>
    </div>
</div>
<app-footer class="footer"></app-footer>
